import React, { useState } from "react";
import ReactDOM from "react-dom";
import mapboxgl from 'mapbox-gl';
import district_points from './congressional_districts';
import { Map, NavigationControl, Popup } from "mapbox-gl"; //Popup
//import SlidingPanel from 'react-sliding-side-panel';
//import { Alert } from 'react-alert'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css'
import { loadStripe } from "@stripe/stripe-js";
import "./erate.css";
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
// const stripePromise = loadStripe("pk_test_UioPh8UAiKZrsm53X8ktdqGz00u5zBsfIc");
const stripePromise = loadStripe("pk_live_ugrJETc5YFi9T0s4IiZc3p6J003SJGfBX5");

mapboxgl.accessToken = "pk.eyJ1IjoibmF0aGFuaWVsbG92aW4iLCJhIjoiY2tjYjR2cGE1MTIwbjJzcGZwb2FpcGJhMCJ9.aqPwkUChkKBq0rN7Q7sGoA";

class CodeAndEnglish {
	//Store the english label and the code equivalent
	//For example "Consumer Download Speed" and "consumerDownload"
	constructor(name, code) {
		this.code = code;
		this.name = name;
	}
}
const schoolLib = new CodeAndEnglish("Schools and Libraries", "erate_schools");
const congDist = new CodeAndEnglish("Congressional Districts", "congressional-districts");
const mapTypes = [schoolLib, congDist];

const fips2state = { '01': 'Alabama', '02': 'Alaska', '04': 'Arizona', '05': 'Arkansas', '06': 'California', '08': 'Colorado', '09': 'Connecticut', '10': 'Delaware', '11': 'District of Columbia', '12': 'Florida', '13': 'Georgia', '15': 'Hawaii', '16': 'Idaho', '17': 'Illinois', '18': 'Indiana', '19': 'Iowa', '20': 'Kansas', '21': 'Kentucky', '22': 'Louisiana', '23': 'Maine', '24': 'Maryland', '25': 'Massachusetts', '26': 'Michigan', '27': 'Minnesota', '28': 'Mississippi', '29': 'Missouri', '30': 'Montana', '31': 'Nebraska', '32': 'Nevada', '33': 'New Hampshire', '34': 'New Jersey', '35': 'New Mexico', '36': 'New York', '37': 'North Carolina', '38': 'North Dakota', '39': 'Ohio', '40': 'Oklahoma', '41': 'Oregon', '42': 'Pennsylvania', '44': 'Rhode Island', '45': 'South Carolina', '46': 'South Dakota', '47': 'Tennessee', '48': 'Texas', '49': 'Utah', '50': 'Vermont', '51': 'Virginia', '53': 'Washington', '54': 'West Virginia', '55': 'Wisconsin', '56': 'Wyoming', '60': 'American Samoa', '66': 'Guam', '69': 'Northern Mariana Islands', '72': 'Puerto Rico', '78': 'Virgin Islands' }
export function layerSource(code) {
	let src = {
		"type": "vector",
		"tiles": ["https://storage.googleapis.com/tpi-broadband-map-public/" + code + "/{z}/{x}/{y}.pbf"],
	};
	if (code === 'congressional-districts') {
		src['promoteId'] = 'GEOID';
	}
	return src
}

const ProductDisplay = ({ handleClick, productName, productPrice, productType }) => (
	<section>
		<div className="product">
			<img
				src="/TPILogo.png"
				alt="TPI Logo"
			/>
			<div className="description">
				<h3>Buy Report</h3>
				<h5>{productPrice}</h5>
			</div>
		</div>
		<button type="button" id="checkout-button" role="link" onClick={(e) => handleClick(e, productType)}>
			Checkout
		</button>
	</section>
);

//   const Message = ({ message }) => (
// 	<section>
// 	  <p>{message}</p>
// 	</section>
//   );

const Instructions = ({ handleClick }) => (
	<div className="info-box">
		<h2 onClick={(e) => handleClick(e)}><u>Instructions</u></h2>
		<p>1) Select either <i>Schools and Libraries</i> or <i>Congressional Districts</i> in the dropdown menu.</p>
		<p>2a) Zoom in on the map to find a particular school, library, or congressional district. Note that when zoomed out, each icon indicates multiple schools or libraries. As you zoom in, the icons will become more disaggregated until you can identify individual locations.</p>
		<p>2b) You can also find schools or libraries by selecting <i>Schools and Libraries</i> and typing the name of the school, library, or city of interest into the search bar in the upper right of the screen.</p>
		<p>3) Click on the icon to order your report!</p>
		<p>You will receive the E-Rate Scorecard as a PDF email attachment. Interested in a bulk discount? Contact Mike Jones at mjones@techpolicyinstitute.org.</p>
	</div>
);

export function mapClickerOn(map) {
	map.on("mouseenter", "fill", function () {
		map.getCanvas().style.cursor = "pointer";
	});
	map.on("mouseleave", "fill", function () {
		map.getCanvas().style.cursor = "";
	});

}

//React dropdown form
function SelectOption(props) {
	return <option value={props.value}>{props.value}</option>;
}
export function DropdownForm(props) {
	return <form id={props.id} className="dropdown">
		<select id="geography" value={props.value} onChange={props.onChangeFunction}>
			{props.data.map((dataElement) => dataElement.name).map((name) => <SelectOption key={name} value={name} />)}
		</select>
	</form>;
}

//Mapbox information popup
export function PopupText(props) {
	return (
		<div id={props.id}>
			<p>School: {props.name}</p>
		</div>
	);
}

export function layerMaker(code, outline) {
	console.log(code);
	if (code === "erate_schools") {
		return {
			"id": "fill",
			"type": "symbol",
			/* Add a GeoJSON source containing place coordinates and information. */
			"source": 'erate_schools',
			"source-layer": "erate_schools",
			// 'paint': {
			// 	'circle-radius': 4,
			// 	'circle-color': 'blue' //'#9c0404'
			// }
			"layout": {
				'icon-image': 'mortar-board',
				'icon-size': .05
			}
		}
	}
	else if (outline) {
		return {
			"id": "outline",
			"type": "line",
			"source": code,
			"source-layer": code === "congressional-districts" ? "congressionalDistricts" : code,
			"layout": {
				"line-cap": "round",
				"line-join": "round"
			},
			"paint": {
				"line-opacity": 1,
				"line-color": "rgb(0, 0, 256)",
				"line-width": [
					'case',
					['boolean', ['feature-state', 'hover'], false],
					3,
					1
				]
			}
		};
	}
	else {
		return {
			"id": "fill",
			"type": "fill",
			"source": code,
			"source-layer": code === "congressional-districts" ? "congressionalDistricts" : code,
			"paint": {
				//Array for colors for polygons
				"fill-color": "rgb(256, 256, 256)",
				"fill-opacity": [
					'case',
					['boolean', ['feature-state', 'hover'], false],
					1,
					0
				]
			}
		};
	}
}

export class MainMap extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			map: null,
			geocoder: null,
			lng: -91.5375,
			lat: 41.6615,
			zoom: 4,
			openPanel: false,
			instructions: false,
			schoolName: "",
			ben: "",
			ren: "",
			congressionalDistrict: "",
			congressionalDistrictID: "",
			mapType: schoolLib,
			mapTypes: mapTypes,
			image: "https://upload.wikimedia.org/wikipedia/commons/7/71/Emojione_1F3EB.svg",
			hoverID: null,
			congressionalDistrictGeocoder: false,
			mousePositionLeft: 40,
			mousePositionRight: 50,
			initialClick: true
		};
		this.popUpRef = React.createRef();
		this.handleMapClick = this.handleMapClick.bind(this);
		this.handleStripeClick = this.handleStripeClick.bind(this);
		this.setOpenPanel = this.setOpenPanel.bind(this);
		this.setSchoolName = this.setSchoolName.bind(this);
		this.setBEN = this.setBEN.bind(this);
		this.setREN = this.setREN.bind(this);
		this.setImage = this.setImage.bind(this);
		this.setCongressionalDistrict = this.setCongressionalDistrict.bind(this);
		this.setCongressionalDistrictID = this.setCongressionalDistrictID.bind(this);
		this.handleAreaChange = this.handleAreaChange.bind(this);
		this.setInstructions = this.setInstructions.bind(this);
		this.setHoverID = this.setHoverID.bind(this);
		this.setMousePositionLeft = this.setMousePositionLeft.bind(this);
		this.setMousePositionRight = this.setMousePositionRight.bind(this);
	}

	setOpenPanel(setting) {
		this.setState({ openPanel: setting });
	}

	setInstructions() {
		console.log("Flip instructions");
		console.log("Current state:" + this.state.instructions);
		this.setState({ instructions: !this.state.instructions });
	}

	setSchoolName(name) {
		this.setState({ schoolName: name });
	}

	setBEN(ben) {
		this.setState({ ben: ben });
	}

	setREN(ren) {
		this.setState({ ren: ren });
	}

	setImage(image) {
		this.setState({ image: image });
	}


	setCongressionalDistrict(congressionalDistrict) {
		this.setState({ congressionalDistrict: congressionalDistrict });
	}

	setCongressionalDistrictID(congressionalDistrictID) {
		this.setState({ congressionalDistrictID: congressionalDistrictID });
	}

	setHoverID(hoverID) {
		this.setState({ hoverID: hoverID });
	}

	setMousePositionLeft(mousePositionLeft) {
		this.setState({ mousePositionLeft: mousePositionLeft});
	}

	setMousePositionRight(mousePositionRight) {
		this.setState({ mousePositionRight: mousePositionRight });
	}

	async handleMapClick(event) {
		if (event.features.length) {
			console.log(event.features[0].properties);
			// Set up Map pop-up
			const popupNode = document.createElement("div");
			console.log(event.features[0].properties);
			ReactDOM.render(<div><h1 className="name">{this.state.mapType === schoolLib ? event.features[0].properties['ros_entity_name'] : fips2state[event.features[0].properties["STATEFP"]] + " " + event.features[0].properties["NAMELSAD"]}</h1>
				<br />
				<ProductDisplay handleClick={this.handleStripeClick} productName={this.state.mapType === schoolLib ? this.state.schoolName : this.state.congressionalDistrict} productPrice={"$49.95"} productType={this.state.mapType === schoolLib ? "REN" : "cong-dist"} />
			</div>,
				popupNode);
			const marker = new Popup();
			marker.setDOMContent(popupNode)
				.setLngLat(event.lngLat)
				.addTo(this.state.map);
			// this.setOpenPanel(true);
			if (this.state.mapType === schoolLib) {
				console.log(event.lngLat)
				this.setSchoolName(event.features[0].properties['ros_entity_name']);
				this.setREN(event.features[0].properties['ros_entity_number']);
				this.setBEN(event.features[0].properties['billed_entity_number']);
				// const response = await fetch("/school-photo?long=" + event.lngLat["lng"] + "&lat=" + event.lngLat['lat']);
				// const imageURL = await response.json()
				// this.setImage(imageURL["photo_url"])
			}
			else {
				const stateName = fips2state[event.features[0].properties["STATEFP"]];
				this.setCongressionalDistrict(stateName + " " + event.features[0].properties["NAMELSAD"]);
				this.setCongressionalDistrictID(event.features[0].properties["GEOID"]);
			}
		}
	}

	handleAreaChange(event) {
		if (this.state.map) {
			if (this.state.map.getLayer("outline")) {
				this.state.map.off("click", "outline", this.handleMapClick);
				this.state.map.off('hover', 'outline');
				this.state.map.removeLayer("outline");
			}
			if (this.state.map.getLayer("fill")) {
				this.state.map.removeLayer("fill");
			}
			this.state.map.removeSource(this.state.mapType.code);
		}
		console.log(event)
		const newArea = this.state.mapTypes.find(e => e.name === event.target.value);
		this.setState({
			mapType: newArea,
			openPanel: false,
			schoolName: "",
			ben: "",
			ren: "",
			congressionalDistrict: "",
			congressionalDistrictID: ""
		}, this.replaceSource);
		mapClickerOn(this.state.map);
	}

	replaceSource() {
		if (this.state.map) {
			console.log(this.state.mapType.code);
			this.state.map.addSource(this.state.mapType.code, layerSource(this.state.mapType.code));
			this.state.map.loadImage('https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Mortar_Board_%2861740%29_-_The_Noun_Project.svg/500px-Mortar_Board_%2861740%29_-_The_Noun_Project.svg.png', function (error, image) { if (error) throw error; this.state.map.addImage('mortar-board', image) });
			this.state.map.addLayer(layerMaker(this.state.mapType.code, false));
			if (this.state.mapType.code !== "erate_schools") {
				this.state.map.addLayer(layerMaker(this.state.mapType.code, true));
				this.state.map.on('mousemove', 'fill', (e) => {
					if (e.features.length > 0) {
						if (this.state.hoverID !== null) {
							this.state.map.setFeatureState(
								{ source: this.state.mapType.code, id: this.state.hoverID, sourceLayer: this.state.mapType.code === "congressional-districts" ? "congressionalDistricts" : this.state.mapType.code },
								{ hover: false }
							);
						}
						this.setHoverID(e.features[0].id);
						this.state.map.setFeatureState(
							{ source: this.state.mapType.code, id: this.state.hoverID, sourceLayer: this.state.mapType.code === "congressional-districts" ? "congressionalDistricts" : this.state.mapType.code },
							{ hover: true }
						);
					}
				});
				this.state.map.on('mouseleave', 'fill', () => {
					if (this.state.hoverID !== null) {
						this.state.map.setFeatureState(
							{ source: this.state.mapType.code, id: this.state.hoverID, sourceLayer: this.state.mapType.code === "congressional-districts" ? "congressionalDistricts" : this.state.mapType.code },
							{ hover: false }
						);
					}
					this.setHoverID(null);
				});
				// document.getElementsByClassName("mapboxgl-ctrl-geocoder")[0].style.display = "none"
			}
			// else{
			// document.getElementsByClassName("mapboxgl-ctrl-geocoder")[0].style.display = "block"
			// }
			this.state.map.on("click", "fill", this.handleMapClick);
		}
	}

	async handleStripeClick(event, productType) {
		const stripe = await stripePromise;
		const product = (this.state.mapType === schoolLib ? this.state.schoolName : this.state.congressionalDistrict) + ' Report';
		const number = this.state.mapType === schoolLib ? this.state.ren : this.state.congressionalDistrictID;
		const ben = this.state.mapType === schoolLib ? this.state.ben : this.state.congressionalDistrictID;
		const response = await fetch("/create-checkout-session", {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			method: "POST",
			body: JSON.stringify({ product: product, productType: productType, number: number, ben: ben })
		});

		const session = await response.json();

		// When the customer clicks on the button, redirect them to Checkout.
		console.log(session);
		const result = await stripe.redirectToCheckout({
			sessionId: session.id,
		});

		if (result.error) {
			// If `redirectToCheckout` fails due to a browser or network
			// error, display the localized error message to your customer
			// using `result.error.message`.
		}
	};

	componentDidMount() {
		const params = new URLSearchParams(window.location.search);
		//Set up Mapbox Map
		const map = new Map({
			container: this.mapContainer,
			style: "mapbox://styles/mapbox/streets-v11",
			center: [this.state.lng, this.state.lat],
			zoom: this.state.zoom,
			maxBounds: [[-173, 16], [-64, 73]]
		});

		map.on("move", () => {
			this.setState({
				lng: map.getCenter().lng.toFixed(4),
				lat: map.getCenter().lat.toFixed(4),
				zoom: map.getZoom().toFixed(2)
			});
		});


		map.on("load", () => {
			map.addSource("erate_schools", layerSource("erate_schools"));
			map.loadImage('https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Mortar_Board_%2861740%29_-_The_Noun_Project.svg/500px-Mortar_Board_%2861740%29_-_The_Noun_Project.svg.png', function (error, image) { if (error) throw error; map.addImage('mortar-board', image) });
			map.addLayer(layerMaker("erate_schools", false));
			map.addControl(new NavigationControl());
			this.setState({ map: map });
		});

		mapClickerOn(map);
		map.on("click", "fill", this.handleMapClick);
		const state_to_abbr = {
			'Alabama': 'AL',
			'Alaska': 'AK',
			'American Samoa': 'AS',
			'Arizona': 'AZ',
			'Arkansas': 'AR',
			'California': 'CA',
			'Colorado': 'CO',
			'Connecticut': 'CT',
			'Delaware': 'DE',
			'District of Columbia': 'DC',
			'Florida': 'FL',
			'Georgia': 'GA',
			'Guam': 'GU',
			'Hawaii': 'HI',
			'Idaho': 'ID',
			'Illinois': 'IL',
			'Indiana': 'IN',
			'Iowa': 'IA',
			'Kansas': 'KS',
			'Kentucky': 'KY',
			'Louisiana': 'LA',
			'Maine': 'ME',
			'Maryland': 'MD',
			'Massachusetts': 'MA',
			'Michigan': 'MI',
			'Minnesota': 'MN',
			'Mississippi': 'MS',
			'Missouri': 'MO',
			'Montana': 'MT',
			'Nebraska': 'NE',
			'Nevada': 'NV',
			'New Hampshire': 'NH',
			'New Jersey': 'NJ',
			'New Mexico': 'NM',
			'New York': 'NY',
			'North Carolina': 'NC',
			'North Dakota': 'ND',
			'Northern Mariana Islands': 'MP',
			'Ohio': 'OH',
			'Oklahoma': 'OK',
			'Oregon': 'OR',
			'Pennsylvania': 'PA',
			'Puerto Rico': 'PR',
			'Rhode Island': 'RI',
			'South Carolina': 'SC',
			'South Dakota': 'SD',
			'Tennessee': 'TN',
			'Texas': 'TX',
			'Utah': 'UT',
			'Vermont': 'VT',
			'Virgin Islands': 'VI',
			'Virginia': 'VA',
			'Washington': 'WA',
			'West Virginia': 'WV',
			'Wisconsin': 'WI',
			'Wyoming': 'WY'
		};

		let forwardGeocoder = (query) => {
			let matchingFeatures = [];
			for (let i = 0; i < district_points.features.length; i++) {
				let feature = district_points.features[i];
				let regex = new RegExp(/(\D*)( Congressional District \d\d)/i)
				let abbr_title = feature.properties.title.replace(regex, (_, p2, p3) => state_to_abbr[p2] + p3);
				if (
					feature.properties.title.toLowerCase().search(query.toLowerCase()) !== -1 ||
					abbr_title.toLowerCase().search(query.toLowerCase()) !== -1
				) {
					feature['place_name'] = abbr_title;
					feature['center'] = feature.geometry.coordinates;
					feature['place_type'] = ['congressional district'];
					matchingFeatures.push(feature);
				}
			}
			return matchingFeatures;
		}

		const geocoder = new MapboxGeocoder({
			accessToken: mapboxgl.accessToken,
			mapboxgl: mapboxgl,
			autocomplete: true,
			proximity: { longitude: this.state.lng, latitude: this.state.lat },
			localGeocoder: forwardGeocoder,
			bbox: [-173, 16, -64, 73]
		});

		this.setState({ geocoder: geocoder })
		map.addControl(geocoder);

		const geolocate = new mapboxgl.GeolocateControl({
			positionOptions: {
				enableHighAccuracy: false
			},
			trackUserLocation: true
		});
		
		map.addControl(geolocate);

		const getLocation = () => {
			let locatorElements = document.getElementsByClassName('mapboxgl-ctrl-geolocate');
			if (locatorElements.length) {
				locatorElements[0].click();
				return;
			}
			setTimeout(getLocation, 500);
		}
		setTimeout(getLocation, 500);

		console.log(this.state.mapType.name);
		// if (params.get("congress")) {
		// 	console.log("congress");
		// 	if(this.state.map){
		// 		this.handleAreaChange({"target":{"value": "Congressional Districts"}});
		// 	}
		// 	else{
				
		// }
	}

	updateMousePosition = (ev) => {
		this.setMousePositionLeft(ev.pageX + 17);
		this.setMousePositionRight(ev.pageY - 18);
	}

	render() {
		const districtName = {
			'00': 'Congressional District (at Large)',
			'98': 'Resident Commissioner District (at Large)'
		}
		return (
			<div onMouseMove={this.updateMousePosition}>
				<div className={this.state.hoverID ? "label" : "none"} style={{left: `${this.state.mousePositionLeft}px`, top: `${this.state.mousePositionRight}px`}}>
					{this.state.hoverID && `${fips2state[this.state.hoverID.slice(0, 2)] ? fips2state[this.state.hoverID.slice(0, 2)] : this.state.hoverID.slice(0, 2)} ${districtName[this.state.hoverID.slice(2)] ? districtName[this.state.hoverID.slice(2)] : `Congressional District ${this.state.hoverID.slice(2)}`}`}
				</div>
				<div ref={el => this.mapContainer = el} className="mapContainer" />
				<ul className="navigation">
					<div className="homebutton"><a href="http://tpireports.com/erate"><img src="TPILogo.png" alt="HTML tutorial" style={{ width: 50 + 'px', height: 50 + 'px' }} /></a>
						<h1 className="name" id="title"> E-Rate Reports </h1></div>
				</ul>
				<div className="dropdown-box">
					<DropdownForm id="mapTypeForm" value={this.state.mapType.name}
						onChangeFunction={this.handleAreaChange} data={this.state.mapTypes} />
				</div>
				{this.state.instructions === true && <Instructions handleClick={this.setInstructions} />}
				{this.state.instructions === false && <div className="instruction-button"><h2 onClick={() => this.setInstructions()}><u>Instructions</u></h2></div>}
				{/*I still don't know why the backdropClicked isn't working*/}
				{/* <SlidingPanel
					type={'right'}
					isOpen={this.state.openPanel}
					backdropClicked={() => this.setOpenPanel(false)}
					size={50}
					panelClassName="additional-class"
					noBackdrop={true}
				>
				<div className="panel-container">
				<h1 className="name">{this.state.mapType === schoolLib ? this.state.schoolName : this.state.congressionalDistrict}</h1>
					{/* <iframe src={"http://127.0.0.1:5000/erateGraph?ben=" + this.state.ben} title={this.state.schoolName + " district graphs"}></iframe> * /}
					<button type="button" className="generate-button" onClick={() => window.open('http://127.0.0.1:5000/generateReport?school=' + this.state.ren,'_blank')}>Generate Report</button>
					{/* <ProductDisplay handleClick={this.handleStripeClick} productName={this.state.mapType === schoolLib ? this.state.schoolName : this.state.congressionalDistrict} productPrice={this.state.mapType === schoolLib ? "$249.00" : "$199.00"} productType={this.state.mapType === schoolLib ? "REN" : "cong-dist"}/> */}
				{/*need to add BEN names to tiles*/}
				{/*{this.state.mapType === schoolLib && <ProductDisplay handleClick={this.handleStripeClick} productName={this.state.ben} productPrice={"$500.00"} productType={"BEN"}/>}* /}
					<button type="button" className="close-button" onClick={() => this.setOpenPanel(false)}>
						close
					</button>
					</div>
				</SlidingPanel> */}
			</div>
		)
	}

}
